var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 142,
    viewBox: "0 0 28 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.160599 76.5C-1.3394 62.5 7.92765 52.1914 17.1608 39C24.1602 29 27.1606 10.5 27.1606 0L27.1599 142C27.1599 120.5 21.6599 113 15.6599 105.5C9.65985 98 1.6606 90.5 0.160599 76.5Z",
    fill: "#070710"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRight);
export default __webpack_public_path__ + "static/media/shape_right.58af3bc6229a526545fed6655ae243d9.svg";
export { ForwardRef as ReactComponent };